import { Grid, GridProps } from '@mui/material';

const GridContainer: React.FC<GridProps> = ({ children, ...rest }) => {
  return (
    <Grid container spacing={6} {...rest}>
      {children}
    </Grid>
  );
};

export default GridContainer;
